import React from 'react';
import { connect } from 'react-redux';
import { Box } from '@mui/material';

import { State as RootState } from '@occc-app/rootRedux';

import { actions as getStartedActions, State as GetStartedState } from '../GetStarted';
import { MetaDataConfigurationGetStarted } from '../GetStarted/components';
import { actions as metaDataActions, State as MetaDataState } from '../Summary';
import { MetaDataConfigurationSummary } from '../Summary/components';

type Actions = typeof getStartedActions & typeof metaDataActions;

type MetaDataConfigurationBaseProps = {
  fieldDisabled: (field: any) => boolean;
};

type State = { getStarted: GetStartedState; metaData: MetaDataState };
type Props = State & Actions & { readOnly: boolean };
class ShowOfferDetails extends React.Component<Props, {}> {
  render() {
    const { getStarted, getStartedUpdate, metaData, readOnly } = this.props;

    const metaDataBaseProps: MetaDataConfigurationBaseProps = {
      fieldDisabled: () => readOnly,
    };

    const getStartedProps = {
      ...metaDataBaseProps,
      ...getStarted,
      getStartedUpdate,
    };

    const metaDataProps = {
      ...metaDataBaseProps,
      ...metaData,
    };

    return (
      <Box>
        <MetaDataConfigurationGetStarted {...getStartedProps} />
        <MetaDataConfigurationSummary {...metaDataProps} />
      </Box>
    );
  }
}

type MapStateToProps = (state: RootState) => State;
const mapStateToProps: MapStateToProps = ({ offer: { getStarted, metaData } }) => ({
  getStarted,
  metaData,
});

const allActions: Actions = {
  ...getStartedActions,
  ...metaDataActions,
};

export default connect(mapStateToProps, allActions)(ShowOfferDetails);
